module.exports = __webpack_public_path__ + "img/援外.6eed4ee2.jpg";